<template>
	<div class="app">
		<router-view></router-view>
		<BlumarAlert></BlumarAlert>
		<BlumarLoading></BlumarLoading>
	</div>
</template>

<script>
import BlumarAlert from './components/shared/BlumarAlert.vue';
import BlumarLoading from './components/shared/BlumarLoading.vue';
import { translate } from './assets/translations';
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
	components: { BlumarAlert, BlumarLoading },
	computed: {
		translation() {
			return translate(this.$store.state.language).head;
		},
	},
  metaInfo() {
		return {
			title: this.translation.title,
			meta: [
				{
					name:'description',
					content: this.translation.description
				},
				{
					name:'keywords',
					content: this.translation.keywords
				},
				{
					property: 'og:description',
					content: this.translation.ogDescription
				},
				{
					property: 'og:type',
					content: 'website'
				},
				{
					property: 'og:title',
					content: ' Blumar Reservas Onlime'
				},
			],
		}
	},
};
</script>

<style lang="scss">
@import '../node_modules/bootstrap/scss/bootstrap.scss';
@import '../node_modules/bootstrap-vue/src/index.scss';

html {
  scroll-behavior: smooth;
}

body {
	margin: 0;
	font-family: 'Helvetica Neue','Helvetica','Arial','sans-serif';
  font-size: 14px;
	line-height: 20px;
	color: #333;
	background-color: #eeeeec;
}

ul {
	list-style-type: none;
	margin: 0;
	padding: 0;
}

.grey-btn {
  width: auto;
  background: #eee;
	font-weight: bold;
  color: #22b0a0;
  border: none;
  box-shadow: 0px 1px 2px #ccc;
  padding: 5px 10px;
  cursor: pointer;
}

.green-btn {
    display: block;
		width: fit-content;
		margin-top: 10px;
		margin-left: auto;
		border: none;
		background: #22b0a0;
		color: white;
		padding: 5px 10px;
		box-shadow: 0px 2px 4px #ccc;
		cursor: pointer;
}

a {
	text-decoration: none;
	color: inherit;
}
a:hover {
	color: #42bc97;
}
.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}
.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}
.slide-enter-to, .slide-leave {
  max-height: 500px;
  overflow: hidden;
}
.slide-enter, .slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

.red{
	color: red;
}

.pagination-box {
	.page-item.active .page-link {
		background-color: #163247 !important;
		color: white !important;
	}
	.page-link {
		color: #163247 !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue